export const CreateShareCodeApi = Symbol('CreateShareCodeApi');
